exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block__wrapper[data-v-52824477] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.block__wrapper .block__item[data-v-52824477] {\n  flex: 1 0 33.3333%;\n}\n.block__wrapper .block__item[data-v-52824477]:first-child {\n  margin-bottom: 24px;\n}", ""]);

// exports
